import React from 'react';
import Dropdown from '../../../Base/Dropdown';

const Title = ({ value }) => (
  <>
    <div
      className="form-item"
      style={
        value
          ? { paddingRight: 50, width: '100%' }
          : { opacity: 0.4, paddingRight: 50, width: '100%' }
      }
    >
      {value || 'Field'}
    </div>
    <div className="field-icon field-icon--right">
      <i className="fas fa-chevron-down" />
    </div>
  </>
);

const SelectField = ({ value = 'id', label = 'ID', data = [], onChange }) => {
  const handleChange = e => {
    onChange(e.currentTarget.dataset.value);
  };

  return (
    <>
      <Dropdown
        title={
          <Title value={data?.find(item => item.value === value)?.label || ''} />
        }
        position="right"
      >
        <ul className="dash-nav__list">
          {data?.map(item => (
            <li key={item?.value}>
              <button
                type="button"
                className="drop-option"
                data-value={item?.value}
                onClick={handleChange}
              >
                <span
                  className="drop-title drop-title-name"
                  style={{ textTransform: 'capitalize' }}
                >
                  {item?.label}
                </span>
              </button>
            </li>
          ))}
        </ul>
      </Dropdown>

      {/* divider  */}
      <div style={{ margin: '0 5px' }} />
    </>
  );
};

export default SelectField;
